const cartas = [
    {
        idoriginal: 0,
        key: 0,
        imgfrente: './imagens/cartas/acoes/Ajudar.png',
        titulofrente: 'Ajudar',
        titulofrenteingles: 'To Help',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 1,
        key: 1,
        imgfrente: './imagens/cartas/acoes/Atrapalhar.png',
        titulofrente: 'Atrapalhar',
        titulofrenteingles: 'To Disturb',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 2,
        key: 2,
        imgfrente: './imagens/cartas/acoes/Brigar.png',
        titulofrente: 'Brigar',
        titulofrenteingles: 'To Fight',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 3,
        key: 3,
        imgfrente: './imagens/cartas/acoes/Brincar.png',
        titulofrente: 'Brincar',
        titulofrenteingles: 'To Play',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 4,
        key: 4,
        imgfrente: './imagens/cartas/acoes/Chorar.png',
        titulofrente: 'Chorar',
        titulofrenteingles: 'To Cry',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 5,
        key: 5,
        imgfrente: './imagens/cartas/acoes/Comer.png',
        titulofrente: 'Comer',
        titulofrenteingles: 'To Eat',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 6,
        key: 6,
        imgfrente: './imagens/cartas/acoes/Convidar.png',
        titulofrente: 'Convidar',
        titulofrenteingles: 'To Invite',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 7,
        key: 7,
        imgfrente: './imagens/cartas/acoes/Cozinhar.png',
        titulofrente: 'Cozinhar',
        titulofrenteingles: 'To Cook',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 8,
        key: 8,
        imgfrente: './imagens/cartas/acoes/Doer.png',
        titulofrente: 'Doer',
        titulofrenteingles: 'To Feel Pain',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 9,
        key: 9,
        imgfrente: './imagens/cartas/acoes/Enjoar.png',
        titulofrente: 'Enjoar',
        titulofrenteingles: 'To Nauseate',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 10,
        key: 10,
        imgfrente: './imagens/cartas/acoes/Ensinar.png',
        titulofrente: 'Ensinar',
        titulofrenteingles: 'To Teach',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 11,
        key: 11,
        imgfrente: './imagens/cartas/acoes/Escovar.png',
        titulofrente: 'Escovar',
        titulofrenteingles: 'To Brush',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 12,
        key: 12,
        imgfrente: './imagens/cartas/acoes/Esquecer.png',
        titulofrente: 'Esquecer',
        titulofrenteingles: 'To Forget',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 13,
        key: 13,
        imgfrente: './imagens/cartas/acoes/Lavar.png',
        titulofrente: 'Lavar',
        titulofrenteingles: 'To Wash',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 14,
        key: 14,
        imgfrente: './imagens/cartas/acoes/Limpar.png',
        titulofrente: 'Limpar',
        titulofrenteingles: 'To Clean',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 15,
        key: 15,
        imgfrente: './imagens/cartas/acoes/Medir.png',
        titulofrente: 'Medir',
        titulofrenteingles: 'To Measure',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 16,
        key: 16,
        imgfrente: './imagens/cartas/acoes/Melhorar.png',
        titulofrente: 'Melhorar',
        titulofrenteingles: 'To Improve',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 17,
        key: 17,
        imgfrente: './imagens/cartas/acoes/Piorar.png',
        titulofrente: 'Piorar',
        titulofrenteingles: 'To get Worse',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 18,
        key: 18,
        imgfrente: './imagens/cartas/acoes/Sujar.png',
        titulofrente: 'Sujar',
        titulofrenteingles: 'To Get Dirty',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 19,
        key: 19,
        imgfrente: './imagens/cartas/acoes/Vacinar.png',
        titulofrente: 'Vacinar',
        titulofrenteingles: 'To Vaccinate',
	imgverso: './imagens/cartas/fundos/Acoes.png',
        tituloverso: 'Ações',
	tituloversoingles: 'Actions',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'ACOES',

    },
    {
        idoriginal: 20,
        key: 20,
        imgfrente: './imagens/cartas/lugares/Banheiro.png',
        titulofrente: 'Banheiro',
        titulofrenteingles: 'Restroom',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 21,
        key: 21,
        imgfrente: './imagens/cartas/lugares/Consultorio.png',
        titulofrente: 'Consultorio',
        titulofrenteingles: 'Clinic',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 22,
        key: 22,
        imgfrente: './imagens/cartas/lugares/Cozinha.png',
        titulofrente: 'Cozinha',
        titulofrenteingles: 'Kitchen',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 23,
        key: 23,
        imgfrente: './imagens/cartas/lugares/Dentista.png',
        titulofrente: 'Dentista',
        titulofrenteingles: 'Dentist',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 24,
        key: 24,
        imgfrente: './imagens/cartas/lugares/Escola.png',
        titulofrente: 'Escola',
        titulofrenteingles: 'School',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 25,
        key: 25,
        imgfrente: './imagens/cartas/lugares/Feira.png',
        titulofrente: 'Feira',
        titulofrenteingles: 'Market',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 26,
        key: 26,
        imgfrente: './imagens/cartas/lugares/Festa.png',
        titulofrente: 'Festa',
        titulofrenteingles: 'Party',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 27,
        key: 27,
        imgfrente: './imagens/cartas/lugares/Floresta.png',
        titulofrente: 'Floresta',
        titulofrenteingles: 'Forest',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 28,
        key: 28,
        imgfrente: './imagens/cartas/lugares/Horta.png',
        titulofrente: 'Horta',
        titulofrenteingles: 'Garden',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 29,
        key: 29,
        imgfrente: './imagens/cartas/lugares/Hospital.png',
        titulofrente: 'Hospital',
        titulofrenteingles: 'Hospital',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 30,
        key: 30,
        imgfrente: './imagens/cartas/lugares/Ilha.png',
        titulofrente: 'Ilha',
        titulofrenteingles: 'Island',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 31,
        key: 31,
        imgfrente: './imagens/cartas/lugares/Montanha.png',
        titulofrente: 'Montanha',
        titulofrenteingles: 'Mountain',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 32,
        key: 32,
        imgfrente: './imagens/cartas/lugares/Parque.png',
        titulofrente: 'Parque',
        titulofrenteingles: 'Park',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 33,
        key: 33,
        imgfrente: './imagens/cartas/lugares/Piscina.png',
        titulofrente: 'Piscina',
        titulofrenteingles: 'Pool',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 34,
        key: 34,
        imgfrente: './imagens/cartas/lugares/Restaurante.png',
        titulofrente: 'Restaurante',
        titulofrenteingles: 'Restaurant',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 35,
        key: 35,
        imgfrente: './imagens/cartas/lugares/Shopping.png',
        titulofrente: 'Shopping',
        titulofrenteingles: 'Shopping',
	imgverso: './imagens/cartas/fundos/Lugares.png',
        tituloverso: 'Lugares',
	tituloversoingles: 'Places',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'LUGARES',

    },
    {
        idoriginal: 36,
        key: 36,
        imgfrente: './imagens/cartas/objetos/Agua.png',
        titulofrente: 'Agua',
        titulofrenteingles: 'Water',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 37,
        key: 37,
        imgfrente: './imagens/cartas/objetos/Anel.png',
        titulofrente: 'Anel',
        titulofrenteingles: 'Ring',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 38,
        key: 38,
        imgfrente: './imagens/cartas/objetos/Avental.png',
        titulofrente: 'Avental',
        titulofrenteingles: 'Med Coat',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 39,
        key: 39,
        imgfrente: './imagens/cartas/objetos/Banheira.png',
        titulofrente: 'Banheira',
        titulofrenteingles: 'Bathtub',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 40,
        key: 40,
        imgfrente: './imagens/cartas/objetos/Casa.png',
        titulofrente: 'Casa',
        titulofrenteingles: 'Home',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 41,
        key: 41,
        imgfrente: './imagens/cartas/objetos/Chocolate.png',
        titulofrente: 'Chocolate',
        titulofrenteingles: 'Chocolate',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 42,
        key: 42,
        imgfrente: './imagens/cartas/objetos/Coracao.png',
        titulofrente: 'Coracao',
        titulofrenteingles: 'Heart',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 43,
        key: 43,
        imgfrente: './imagens/cartas/objetos/Escova.png',
        titulofrente: 'Escova',
        titulofrenteingles: 'Brush',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 44,
        key: 44,
        imgfrente: './imagens/cartas/objetos/Estetoscopio.png',
        titulofrente: 'Estetoscopio',
        titulofrenteingles: 'Stethoscope',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 45,
        key: 45,
        imgfrente: './imagens/cartas/objetos/Fogao.png',
        titulofrente: 'Fogao',
        titulofrenteingles: 'Cooker',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 46,
        key: 46,
        imgfrente: './imagens/cartas/objetos/Frutas.png',
        titulofrente: 'Frutas',
        titulofrenteingles: 'Fruits',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 47,
        key: 47,
        imgfrente: './imagens/cartas/objetos/Injecao.png',
        titulofrente: 'Injecao',
        titulofrenteingles: 'Injection',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 48,
        key: 48,
        imgfrente: './imagens/cartas/objetos/Leite.png',
        titulofrente: 'Leite',
        titulofrenteingles: 'Milk',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 49,
        key: 49,
        imgfrente: './imagens/cartas/objetos/Livro.png',
        titulofrente: 'Livro',
        titulofrenteingles: 'Book',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 50,
        key: 50,
        imgfrente: './imagens/cartas/objetos/Mochila.png',
        titulofrente: 'Mochila',
        titulofrenteingles: 'Backpack',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 51,
        key: 51,
        imgfrente: './imagens/cartas/objetos/Ovo.png',
        titulofrente: 'Ovo',
        titulofrenteingles: 'Egg',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 52,
        key: 52,
        imgfrente: './imagens/cartas/objetos/Panela.png',
        titulofrente: 'Panela',
        titulofrenteingles: 'Pan',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 53,
        key: 53,
        imgfrente: './imagens/cartas/objetos/Relogio.png',
        titulofrente: 'Relogio',
        titulofrenteingles: 'Watch',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 54,
        key: 54,
        imgfrente: './imagens/cartas/objetos/Remedio.png',
        titulofrente: 'Remedio',
        titulofrenteingles: 'Medicine',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 55,
        key: 55,
        imgfrente: './imagens/cartas/objetos/Sabonete.png',
        titulofrente: 'Sabonete',
        titulofrenteingles: 'Soap',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 56,
        key: 56,
        imgfrente: './imagens/cartas/objetos/Salada.png',
        titulofrente: 'Salada',
        titulofrenteingles: 'Salad',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 57,
        key: 57,
        imgfrente: './imagens/cartas/objetos/Termometro.png',
        titulofrente: 'Termometro',
        titulofrenteingles: 'Thermometer',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 58,
        key: 58,
        imgfrente: './imagens/cartas/objetos/Toalha.png',
        titulofrente: 'Toalha',
        titulofrenteingles: 'Towel',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 59,
        key: 59,
        imgfrente: './imagens/cartas/objetos/Torneira.png',
        titulofrente: 'Torneira',
        titulofrenteingles: 'Tap',
	imgverso: './imagens/cartas/fundos/Objetos.png',
        tituloverso: 'Objetos',
	tituloversoingles: 'Objects',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'OBJETOS',

    },
    {
        idoriginal: 60,
        key: 60,
        imgfrente: './imagens/cartas/personagens/Bruxa.png',
        titulofrente: 'Bruxa',
        titulofrenteingles: 'Witch',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 61,
        key: 61,
        imgfrente: './imagens/cartas/personagens/Cacador.png',
        titulofrente: 'Cacador',
        titulofrenteingles: 'Hunter',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 62,
        key: 62,
        imgfrente: './imagens/cartas/personagens/Cachorro.png',
        titulofrente: 'Cachorro',
        titulofrenteingles: 'Dog',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 63,
        key: 63,
        imgfrente: './imagens/cartas/personagens/Carpinteiro.png',
        titulofrente: 'Carpinteiro',
        titulofrenteingles: 'Carpenter',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 64,
        key: 64,
        imgfrente: './imagens/cartas/personagens/Cientista.png',
        titulofrente: 'Cientista',
        titulofrenteingles: 'Scientist',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 65,
        key: 65,
        imgfrente: './imagens/cartas/personagens/Coelho.png',
        titulofrente: 'Coelho',
        titulofrenteingles: 'Bunny',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 66,
        key: 66,
        imgfrente: './imagens/cartas/personagens/Enfermeira.png',
        titulofrente: 'Enfermeira',
        titulofrenteingles: 'Nurse',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 67,
        key: 67,
        imgfrente: './imagens/cartas/personagens/Fada.png',
        titulofrente: 'Fada',
        titulofrenteingles: 'Fairy',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 68,
        key: 68,
        imgfrente: './imagens/cartas/personagens/Gato.png',
        titulofrente: 'Gato',
        titulofrenteingles: 'Cat',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 69,
        key: 69,
        imgfrente: './imagens/cartas/personagens/Guarda.png',
        titulofrente: 'Guarda',
        titulofrenteingles: 'Guard',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 70,
        key: 70,
        imgfrente: './imagens/cartas/personagens/Mae.png',
        titulofrente: 'Mae',
        titulofrenteingles: 'Mother',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 71,
        key: 71,
        imgfrente: './imagens/cartas/personagens/Medico.png',
        titulofrente: 'Medico',
        titulofrenteingles: 'Doctor',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 72,
        key: 72,
        imgfrente: './imagens/cartas/personagens/Menina.png',
        titulofrente: 'Menina',
        titulofrenteingles: 'Girl',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 73,
        key: 73,
        imgfrente: './imagens/cartas/personagens/Menino.png',
        titulofrente: 'Menino',
        titulofrenteingles: 'Boy',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 74,
        key: 74,
        imgfrente: './imagens/cartas/personagens/Pai.png',
        titulofrente: 'Pai',
        titulofrenteingles: 'Father',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 75,
        key: 75,
        imgfrente: './imagens/cartas/personagens/Pricesa.png',
        titulofrente: 'Pricesa',
        titulofrenteingles: 'Princess',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 76,
        key: 76,
        imgfrente: './imagens/cartas/personagens/Principe.png',
        titulofrente: 'Principe',
        titulofrenteingles: 'Prince',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 77,
        key: 77,
        imgfrente: './imagens/cartas/personagens/Professora.png',
        titulofrente: 'Professora',
        titulofrenteingles: 'Teacher',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 78,
        key: 78,
        imgfrente: './imagens/cartas/personagens/Rei.png',
        titulofrente: 'Rei',
        titulofrenteingles: 'King',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 79,
        key: 79,
        imgfrente: './imagens/cartas/personagens/Urso.png',
        titulofrente: 'Urso',
        titulofrenteingles: 'Bear',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 80,
        key: 80,
        imgfrente: './imagens/cartas/personagens/Velho.png',
        titulofrente: 'Velho',
        titulofrenteingles: 'Old',
	imgverso: './imagens/cartas/fundos/Personagens.png',
        tituloverso: 'Personagens',
	tituloversoingles: 'Characters',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'PERSONAGENS',

    },
    {
        idoriginal: 81,
        key: 81,
        imgfrente: './imagens/cartas/qualidades/Apressado.png',
        titulofrente: 'Apressado',
        titulofrenteingles: 'Rushed',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 82,
        key: 82,
        imgfrente: './imagens/cartas/qualidades/Bagunceiro.png',
        titulofrente: 'Bagunceiro',
        titulofrenteingles: 'Messy',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 83,
        key: 83,
        imgfrente: './imagens/cartas/qualidades/Bonito.png',
        titulofrente: 'Bonito',
        titulofrenteingles: 'Beautiful',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 84,
        key: 84,
        imgfrente: './imagens/cartas/qualidades/Brilhante.png',
        titulofrente: 'Brilhante',
        titulofrenteingles: 'Bright',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 85,
        key: 85,
        imgfrente: './imagens/cartas/qualidades/Chato.png',
        titulofrente: 'Chato',
        titulofrenteingles: 'Boring',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 86,
        key: 86,
        imgfrente: './imagens/cartas/qualidades/Cheiroso.png',
        titulofrente: 'Cheiroso',
        titulofrenteingles: 'Scented',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 87,
        key: 87,
        imgfrente: './imagens/cartas/qualidades/Doente.png',
        titulofrente: 'Doente',
        titulofrenteingles: 'Sick',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 88,
        key: 88,
        imgfrente: './imagens/cartas/qualidades/Egoista.png',
        titulofrente: 'Egoista',
        titulofrenteingles: 'Selfish',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 89,
        key: 89,
        imgfrente: './imagens/cartas/qualidades/Forte.png',
        titulofrente: 'Forte',
        titulofrenteingles: 'Strong',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 90,
        key: 90,
        imgfrente: './imagens/cartas/qualidades/Fraco.png',
        titulofrente: 'Fraco',
        titulofrenteingles: 'Weak',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 91,
        key: 91,
        imgfrente: './imagens/cartas/qualidades/Honesto.png',
        titulofrente: 'Honesto',
        titulofrenteingles: 'Honest',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 92,
        key: 92,
        imgfrente: './imagens/cartas/qualidades/Magro.png',
        titulofrente: 'Magro',
        titulofrenteingles: 'Thin',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 93,
        key: 93,
        imgfrente: './imagens/cartas/qualidades/Malencarado.png',
        titulofrente: 'Malencarado',
        titulofrenteingles: 'Bad guy',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 94,
        key: 94,
        imgfrente: './imagens/cartas/qualidades/Mimado.png',
        titulofrente: 'Mimado',
        titulofrenteingles: 'Spoiled',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 95,
        key: 95,
        imgfrente: './imagens/cartas/qualidades/Nojento.png',
        titulofrente: 'Nojento',
        titulofrenteingles: 'Nasty',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 96,
        key: 96,
        imgfrente: './imagens/cartas/qualidades/Perfumado.png',
        titulofrente: 'Perfumado',
        titulofrenteingles: 'Fragant',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 97,
        key: 97,
        imgfrente: './imagens/cartas/qualidades/Queimado.png',
        titulofrente: 'Queimado',
        titulofrenteingles: 'Burned',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 98,
        key: 98,
        imgfrente: './imagens/cartas/qualidades/Simpatico.png',
        titulofrente: 'Simpatico',
        titulofrenteingles: 'Nice',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
    {
        idoriginal: 99,
        key: 99,
        imgfrente: './imagens/cartas/qualidades/Triste.png',
        titulofrente: 'Triste',
        titulofrenteingles: 'Sad',
	imgverso: './imagens/cartas/fundos/Qualidades.png',
        tituloverso: 'Qualidades',
	tituloversoingles: 'Qualities',
        jogador: 0,
        jaescolhida: false,
        frente: false,
        selecionada: false,
	categoria: 'QUALIDADES',

    },
];

export default cartas



// WEBPACK FOOTER //
// ./src/util/cartas.js